import { render, staticRenderFns } from "./LogoField.vue?vue&type=template&id=12f76c95&"
import script from "./LogoField.vue?vue&type=script&lang=js&"
export * from "./LogoField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports